import { HubsSettingClient } from 'frontend-preferences-client';
import { PromiseClient } from 'hub-http/adapters/promiseClient';
import { fromHttpPromise } from 'pulse/adapters';
import { ResolverHttpClient } from 'pulse/resolvers';
import { batchScheduler } from 'batch-promise';
import type { HubSettingParams } from './types';

const hubsSettingClient = HubsSettingClient.forCaller('hs-resources');

type SchedulerCall = HubSettingParams & { httpClient: ResolverHttpClient };

const scheduler = batchScheduler()
  .read<SchedulerCall>()
  .identity(({ settingName }) => settingName)
  .partition(() => 'hubSettings')
  .execute((calls) => {
    const callsArray = Object.values(calls);
    const httpClient = callsArray[0].httpClient as PromiseClient;
    const defaults: Record<string, string> = {};
    for (const call of callsArray) {
      defaults[call.settingName] = '';
    }
    return hubsSettingClient.withHttpClient(httpClient).batchFetch(defaults);
  })
  .extract(({ response, input }) => response[input.settingName] ?? '')
  .immediate();

const fetchHubSetting = (
  httpClient: ResolverHttpClient,
  params: HubSettingParams
): Promise<string> => scheduler.queue({ httpClient, ...params });

export const defaultHubSettingResolver = fromHttpPromise<
  string,
  HubSettingParams
>('hubSettingResolver', fetchHubSetting);

export const __TEST_ONLY_abortHubSettingScheduler = () => scheduler.abort();
